var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",on:{"click":_vm.addProduct}},[_vm._t("default",function(){return [_vm._m(0),_c('span',{directives:[{name:"t",rawName:"v-t",value:('sale.actions.add_products'),expression:"'sale.actions.add_products'"}]})]})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon"},[_c('i',{staticClass:"mdi mdi-tag-plus-outline"})])
}]

export { render, staticRenderFns }